<template>
  <v-dialog v-model="dialogStatus" max-width="800" transition="dialog-bottom-transition" scrollable>
    <v-card class="mx-auto">
      <div class="d-flex align-end my-3">
        <v-card class="green py-4 px-4 ml-6 mr-3 mt-6">
          <v-icon color="white"> mdi-bookmark </v-icon>
        </v-card>
        <span class="h4 ml-1 mb-n1">版本发布信息</span>
      </div>
      <v-card-text>
        <v-form ref="form" v-model="valid" class="px-15 mt-8" :style="{padding:isMobile.isMobile?'0 0px !important':'60px'}">
          <div>
            <div class="uploadWrap">
              <span style="font-size: 14px; color: #000"
                >封面图

                <md-tooltip style="z-index: 999" md-direction="top"
                  >推荐尺寸为190(长)*340(宽)的封面图片</md-tooltip
                >
              </span>
              <el-button
                size="small"
                type="success"
                style="color: #fff; background-color: #4caf50"
                @click="uploadDialog = true"
                >选择图片</el-button
              >

     
            </div>
            <v-dialog v-model="uploadDialog" max-width="800px" persistent>
              <v-card class="card-shadow border-radius-xl">
                <v-card-text class="card-padding">
                  <v-select
                    v-model="form.type"
                    :items="zyTypeList"
                    item-text="name"
                    color="#4caf50"
                    item-value="type"
                    label="类型 *"
                    no-data-text="暂无数据"
                    :rules="[v => !!v || '类型不能为空']"
                    @change="clear"
                    class="mediumType"
                  ></v-select>
                  <v-file-input
                    v-if="form.type == 'img'"
                    truncate-length="15"
                    color="#4caf50"
                    label="封面图片上传"
                    @change="f => (form.preImg = fileChange(f))"
                    v-model="form.preImg"
                    accept="image/*"
                    show-size
                    multiple
                  ></v-file-input>
                  <v-file-input
                    v-if="form.type == 'video'"
                    truncate-length="15"
                    color="#4caf50"
                    label="视频预览图上传"
                    @change="f => (form.videoPreImg = fileChange(f))"
                    v-model="form.preImg"
                    accept="image/*"
                    show-size
                  ></v-file-input>
                  <v-file-input
                    v-if="form.type == 'video'"
                    @change="f => (form.preVideo = fileChange(f))"
                    label="视频上传"
                    :value="form.preVideo"
                    accept="video/*"
                    chips
                    multiple
                  ></v-file-input>
                  <v-card-actions class="card-padding d-flex justify-end">
                    <v-btn
                      elevation="0"
                      :ripple="false"
                      height="35"
                      color="success"
                      class="font-weight-normal text-capitalize btn-ls py-3 px-6"
                      @click="save"
                      :loading="btnloading"
                      >保存</v-btn
                    >
                    <v-btn
                      elevation="0"
                      :ripple="false"
                      height="35"
                      class="font-weight-normal text-capitalize btn-ls btn-outline-secondary bg-transparent py-3 px-6"
                      @click="close"
                      >取消</v-btn
                    >
                  </v-card-actions>

                  <!-- 
            <el-upload
           v-if="getRoute() == 'courseEdit'"
            :show-file-list="false"
            action=""
            :file-list="routeData.bannerImg"
            class="upload-demo"
            list-type="text"
            :http-request="params => httpRequest(params, 'courseDetail')"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'courseDetail')"
            multiple
          >
            <el-button size="small" type="success" style="color: red">点击上传</el-button>
          </el-upload> -->
                </v-card-text>
              </v-card>
            </v-dialog>
            <div :style="{marginTop: '5px', overflow: 'hidden',}" :class="isMobile.isMobile?'MobileImgStyle':''">
              <div
                v-for="item in form.cover"
                :key="item.id"
                :style="{width: isMobile.isMobile?'45%':'20%', margin: '5px', height: '100px', float: 'left', position: 'relative'}"
              >
                <video
                  v-if="item.url.indexOf('.mp4') !== -1"
                  :src="item.url"
                  alt=""
                  style="height: 100%; width: 100%"
                  controls
                ></video>
                <img :src="item.url" alt="" v-else style="height: 100%; width: 100%" />

                <span
                  @click="delImg(item)"
                  class="iconfont icon-shanchutianchong"
                  style="
                    padding: 5px;
                    position: absolute;
                    color: #fff;
                    right: 0px;
                    top: 0px;
                    cursor: pointer;
                  "
                ></span>
              </div>
            </div>

         
          </div>
  
          <v-select
            v-model="form.tag"
            :items="tagAll"
            label="标签"
            multiple
            chips
    
            item-color="green"
            item-text="label"
            item-value="value"
          ></v-select>
          <v-text-field
            v-model="form.version"
            label="版本号 *"
            color="green lighten-1"
            :rules="[
              v => !!v || '版本号不能为空',
              v =>
                /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/.test(v) ||
                '版本号格式不正确,最多输入两位小数',
            ]"
            hint="请输入版本号"
          ></v-text-field>
      
          <p style="font-size: 14px; color: #333">请选择发布的章节及任务</p>
        
          <v-treeview
            v-model="includeTaskDict"
            selectable
            selected-color="green"
            item-key="_id"
            :items="courseTree"
            hint="请选择课程"
          ></v-treeview>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green" dark @click.stop="submit">提交</v-btn>
        <v-btn color="gray" @click.stop="dialogStatus = false">取消</v-btn>
      </v-card-actions>
    </v-card>
    <!-- 加载框 -->
    <v-overlay :value="overlay">
      <v-card class="d-flex flex-column justify-center white px-10">
        <div class="d-flex justify-center py-5">
          <v-progress-circular indeterminate color="success"></v-progress-circular>
        </div>
        <div class="d-flex justify-center pb-5 green--text text-bold">
          {{ uploadProgress }}
        </div>
      </v-card>
    </v-overlay>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import { ossUpload } from '@/api/common';
import { addSimulation, checkSimalationVersion } from '@/api/simulation';
import { queryAllProjectAndTask } from '@/api/course';
import { getossUploadToken } from '@/api/user';
import Oss from 'ali-oss';
export default {
  computed: {
    ...mapGetters(['showPublishVersion', 'project', 'taskList', 'course','isMobile']),
    dialogStatus: {
      get() {
        return this.showPublishVersion;
      },
      set(val) {
        this.$store.dispatch('courseAndProject/reverseShowPublishVersion', val);
      },
    },
  },
  watch: {
    showPublishVersion(val) {
      if (val) {
        this.getTreeData();
        this.$nextTick(() => {
          this.$refs.form.reset();
        });
      }
    },
  },
  data() {
    return {
      uploadDialog: false,
      btnloading: false,
      zyTypeList: [
        {
          type: 'img',
          name: '图片',
          id: 1,
        },
        {
          type: 'video',
          name: '视频',
          id: 2,
        },
      ],
      tagAll: [
        {
          id:1,
          label: 'PC',
          value: 'PC',
        },
        {
          id:2,
          label: 'VR',
          value: 'VR',
        },
        {
          id:3,
          label: 'WebGL',
          value: 'WebGL',
        },
        {
          id:4,
          label: '安卓',
          value: 'Android',
        },
        {
          id:5,
          label: 'ZSpace',
          value: 'ZSpace',
        },
        {
          id:6,
          label: 'KMAX',
          value: 'KMAX',
        },
        {
          id:7,
          label: '单机模式',
          value: 'standalone',
        },
      ],
      tab: '',
      form: {
        cover: [],
        type: 'img',
        preImg: [], //图片
        videoPreImg: '', //视频预览图
        preVideo: [],
        tag:[],
      },
      keywords: '',
      valid: false,
      previewImg: null,
      uploadProgress: '',
      overlay: false,
      currentFile: null,
      courseTree: [],
      selectedItem: 'PC',
      selectedVersion: [],
      includeTaskDict: [],
    };
  },
  methods: {
    async save() {
      let _this = this;
      if (this.form.type == 'img') {
        //图片
        this.btnloading = true;

        const uploadPromises = [];
        for (let i = 0; i < this.form.preImg.length; i++) {
          const file = this.form.preImg[i];
          uploadPromises.push(this.uploadImage(file, 'preImg'));
        }
        Promise.all(uploadPromises)
          .then(addresses => {
            addresses.forEach(item => {
              let obj = {
                id: _this.guid(),
                url: item.url,
              };
              _this.form.cover.push(obj);
            });
            _this.btnloading = false;
            _this.close();
          })
          .catch(error => {
            console.error('上传图片出错:', error);
            _this.close();
          });
      } else {
        //视频
        console.log(this.form.videoPreImg);
        if (!this.form.videoPreImg) {
          this.$notify({
            timeout: 1500,
            message: '请上传视频预览图',
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'warning',
          });
          return;
        }

        _this.btnloading = true;
        let videoPreImg = await this.uploadImage(this.form.videoPreImg, 'videoPreImg');

        const uploadPromises = [];
        for (let i = 0; i < this.form.preVideo.length; i++) {
          const file = this.form.preVideo[i];
          uploadPromises.push(this.uploadImage(file, 'preVideo'));
        }
        Promise.all(uploadPromises)
          .then(addresses => {
            addresses.forEach(item => {
              let obj = {
                id: _this.guid(),
                url: item.url,
                playerOptions: {},
                poster: videoPreImg.url,
              };

              obj.playerOptions = {
                // loop: false, // 导致视频一结束就重新开始。
                // preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                // aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                // fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                controlBar: {
                  timeDivider: true,
                  durationDisplay: true,
                  remainingTimeDisplay: false,
                  fullscreenToggle: true, //全屏按钮
                },
                height: '350',
                autoplay: false, //如果true,浏览器准备好时开始回放。
                muted: false, // 默认情况下将会消除任何音频。
                language: 'en', //zh-CN
                playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
                sources: [
                  {
                    type: 'video/mp4',
                    // mp4
                    src: item.url,
                    // webm
                    // src: "https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm"
                  },
                ],
                poster: videoPreImg.url, //你的封面地址
              };

              _this.form.cover.push(obj);
            });
            _this.btnloading = false;
            _this.close();
          })
          .catch(error => {
            console.error('上传图片出错:', error);
            _this.close();
            _this.btnloading = false;
          });
      }
    },
    close() {
      this.uploadDialog = false;
      this.form.preImg = null;
      this.form.preVideo = null;
    },

    // 单个图片上传函数
    uploadImage(param, type) {
      return new Promise((resolve, reject) => {
        getossUploadToken({})
          .then(result => {
            const creditInfo = result.data;
            const aliOss = new Oss(creditInfo);
            aliOss
              .put(`${type}/${new Date().getTime()}/${param.name}`, param, {
                headers: {
                  'Access-Control-Allow-Origin': '*',
                },
              })
              .then(res => {
                resolve(res);
              });
          })
          .catch(err => {
            reject(err);
            console.log(err);
          });
      });
    },

    guid() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
    beforeUpload(file) {
      const allowedTypes = ['image/jpeg', 'image/png'];
      const isAllowed = allowedTypes.includes(file.type);
      // const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isAllowed) {
        this.$message.error('只能上传JPG/PNG格式的图片!');
      }
      // if (!isLt2M) {
      //   this.$message.error('上传的图片大小不能超过 2MB!');
      // }

      return isAllowed;
    },
    clear() {
      if (this.form.type == 'img') {
        this.form.videoPreImg = null;
        this.form.preVideo = null;
      } else {
        this.form.preImg = null;
      }
    },
    delImg(items) {
      this.form.cover = this.form.cover.filter(item => item.id !== items.id);
    },
    guid() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
    handleSelected(e, value) {
      if (e) {
        this.selectedVersion.push(value);
        return;
      }
      const index = this.selectedVersion.findIndex(item => item === value);
      if (index !== -1) {
        this.selectedVersion.splice(index, 1);
      }
    },
    getTreeData() {
      queryAllProjectAndTask(this.$route.query.detailId).then(res => {
        res.data.forEach((element, index) => {
          element.name = `章节${element.orderNum}. ${element.name}`;
          element.children = element.children.map(item => {
            item.name = `任务${item.sortNum}. ${item.name}`;
            return item;
          });
        });
        this.courseTree = res.data;
      });
    },
    fileChange(e) {
      console.log({
        e,
        f: this.form,
      });
      return e;
    },
    async submit() {
      if (this.form.cover.length <= 0) {
        this.$store.dispatch('global/showWarningMsg', '请选择发布课程预览图片');
        return;
      }

      this.$refs.form.validate();
      if (this.valid) {
        const { version, publishPlatforms, includeTaskDict, tag } = this.form;
        const res = await checkSimalationVersion({
          version,
          courseId: this.course._id,
        });

        if (res.code == 200 && res.data) {
          this.$store.dispatch(
            'global/showWarningMsg',
            '该版本已在编译或已经发布，请重新定义版本号'
          );
          return;
        }
        this.overlay = true
        this.uploadProgress = '数据提交中...';
        // const cover = await this.uploadFile('modelImage', this.currentFile);
        const addRes = await addSimulation({
          courseId: this.course._id,
          version,
          publishPlatforms,
          cover: this.form.cover[0].url,
          bannerImg: this.form.cover,
          includeTaskDict: this.includeTaskDict,
          tag,
          teacherMessage: this.form.teacherMessage,
        });

        if (addRes.code == 200) {
          this.dialogStatus = false;
          this.$store.dispatch(
            'global/showSuccessMsg',
            '课程已经提交编译,可在开发中心 -> 编译申请 查看编译进度'
          );
        } else {
          this.$store.dispatch('global/showWarningMsg', '系统错误，请稍后尝试');
        }
        this.overlay = false;
      } else {
        this.$store.commit('global/SHOW_SNACKBAR', {
          color: 'reg(252, 161, 36)',
          text: '参数校验未通过',
        });
      }
    },
  },
};
</script>
<style>
.choose-img__input {
  width: 80px;
  height: 31px;
  position: absolute;
  left: 0;
  opacity: 0;
}
.check-img__input {
  width: 80px;
  height: 31px;
  position: absolute;
  left: 58px;
  opacity: 0;
}

.MobileImgStyle{
  display: flex;
  justify-content:space-between;
  align-items: center;
  flex-wrap: wrap;
}
</style>
